import { memo } from "react";
import Icon from "./icons";

const SlotQuantity = ({
  data,
  showAddCart,
  showAvailability,
  onSubmit,
  isDisabled = false,
  inCart,
}) => {
  return (
    <>
      <div className="slot-quantity d-flex justify-content-end">
        {showAddCart && (
          <button
            title="Prenota"
            disabled={isDisabled}
            onClick={() => onSubmit(data, 1)}
            className="slot-quantity__btn slot-quantity__btn--add align-self-stretch"
          >
            <Icon name="addcart" />{" "}
            {inCart ? <span>Modifica</span> : <span>Aggiungi</span>}
          </button>
        )}
      </div>
      {showAvailability && (
        <span className="slot-quantity__availability">
          Posti disponibili:<strong> {data.disp}</strong>
          {inCart && (
            <>
              <br />
              Prenotazioni in carrello: <strong> {inCart}</strong>
            </>
          )}
        </span>
      )}
    </>
  );
};

export default memo(SlotQuantity);
